import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
// Listens for the browser's install offer before anything renders (it fires once, early).
import './utils/installApp';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

